import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarIcon from '@mui/icons-material/Star';
import DiamondIcon from '@mui/icons-material/Diamond';

const TIER_CONFIG = [
    { maxPrice: 100, label: 'Basic', icon: StarBorderIcon, color: '#8d9e8f' },
    { maxPrice: 200, label: 'Standard', icon: StarHalfIcon, color: '#5a7d5d' },
    { maxPrice: 300, label: 'Premium', icon: StarIcon, color: '#c9952e' },
    { maxPrice: Infinity, label: 'Elite', icon: DiamondIcon, color: '#6a4fc7' },
];

export function getServiceTier(price) {
    const tier = TIER_CONFIG.find(t => price <= t.maxPrice);
    return tier || TIER_CONFIG[TIER_CONFIG.length - 1];
}
